import organizeImagesWithVariations from "../utils/generateImages";

const imageFilenames = [
    'abstract-cloud-a.png',
    'abstract-cloud-b.png',
    'abstract-cloud-c.png',
    'abstract-cloud-d.png',
    'abstract-shape-1-a.png',
    'abstract-shape-1-b.png',
    'abstract-shape-2-a.png',
    'abstract-shape-2-b.png',
    'abstract-shape-2-c.png',
    'abstract-sphere-a.png',
    'abstract-sphere-b.png',
    'award-a.png',
    'award-b.png',
    'award-c.png',
    'award-d.png',
    'balloon-a.png',
    'balloon-b.png',
    'balloon-c.png',
    'balloon-d.png',
    'balloon-e.png',
    'balloon-f.png',
    'books-set-a.png',
    'books-set-b.png',
    'books-set-c.png',
    'books-set-d.png',
    'books-set-e.png',
    'books-single-a.png',
    'books-single-b.png',
    'books-single-c.png',
    'books-single-d.png',
    'books-single-e.png',
    'bricks-a.png',
    'bricks-b.png',
    'bricks-c.png',
    'building-government-a.png',
    'building-government-b.png',
    'building-government-c.png',
    'building-government-d.png',
    'building-government-e.png',
    'building-government-f.png',
    'building-government-g.png',
    'building-government-h.png',
    'cable-ethernet-a.png',
    'cable-ethernet-b.png',
    'cable-ethernet-c.png',
    'cable-ethernet-d.png',
    'cable-ethernet-e.png',
    'cable-ethernet-f.png',
    'cable-ethernet-g.png',
    'cable-ethernet-h.png',
    'calculator-a.png',
    'calculator-b.png',
    'calculator-c.png',
    'calculator-d.png',
    'cash-register-a.png',
    'cash-register-b.png',
    'cash-register-c.png',
    'check-a.png',
    'check-b.png',
    'check-c.png',
    'check-d.png',
    'chess-knight-a.png',
    'chess-knight-b.png',
    'chess-knight-c.png',
    'chess-knight-d.png',
    'chess-knight-e.png',
    'chess-queen-a.png',
    'chess-queen-b.png',
    'chess-queen-c.png',
    'city-a.png',
    'city-b.png',
    'city-c.png',
    'city-d.png',
    'clipboard-a.png',
    'clipboard-b.png',
    'clipboard-c.png',
    'clipboard-d.png',
    'coins-heaps-a.png',
    'coins-heaps-b.png',
    'coins-heaps-c.png',
    'coins-heaps-d.png',
    'coins-heaps-e.png',
    'coins-heaps-f.png',
    'coins-heaps-g.png',
    'coins-set-a.png',
    'coins-set-b.png',
    'coins-set-c.png',
    'coins-set-d.png',
    'coins-set-e.png',
    'coins-single-a.png',
    'coins-single-b.png',
    'coins-single-c.png',
    'coins-single-d.png',
    'coins-single-e.png',
    'coins-single-f.png',
    'coins-single-g.png',
    'coins-single-h.png',
    'coins-stack-a.png',
    'coins-stack-b.png',
    'coins-stack-c.png',
    'envelope-a.png',
    'envelope-b.png',
    'envelope-c.png',
    'envelope-d.png',
    'face-frown-a.png',
    'face-frown-b.png',
    'face-frown-c.png',
    'face-neutral-a.png',
    'face-neutral-b.png',
    'face-neutral-c.png',
    'face-smile-a.png',
    'face-smile-b.png',
    'face-smile-c.png',
    'gavel-a.png',
    'gavel-b.png',
    'gavel-book-a.png',
    'gavel-book-b.png',
    'gavel-c.png',
    'gavel-d.png',
    'gavel-e.png',
    'gear-1-a.png',
    'gear-1-b.png',
    'gear-2-a.png',
    'gear-2-b.png',
    'gear-2-c.png',
    'glasses-a.png',
    'glasses-b.png',
    'glasses-c.png',
    'globe-a.png',
    'globe-b.png',
    'globe-c.png',
    'globe-d.png',
    'globe-e.png',
    'globe-f.png',
    'globe-g.png',
    'globe-h.png',
    'globe-i.png',
    'graph-bar-a.png',
    'graph-bar-b.png',
    'graph-bar-c.png',
    'graph-bar-d.png',
    'graph-bar-e.png',
    'graph-bar-f.png',
    'graph-bar-g.png',
    'graph-bar-h.png',
    'graph-bar-radial-a.png',
    'graph-bar-radial-b.png',
    'graph-bar-radial-c.png',
    'graph-bar-radial-d.png',
    'graph-pie-a.png',
    'graph-pie-b.png',
    'graph-pie-c.png',
    'graph-pie-d.png',
    'graph-pie-e.png',
    'graph-trend-a.png',
    'graph-trend-b.png',
    'graph-trend-c.png',
    'graph-trend-d.png',
    'graph-trend-e.png',
    'graph-trend-f.png',
    'hands-hold-a.png',
    'hands-hold-b.png',
    'hands-open-a.png',
    'hands-open-b.png',
    'hands-open-c.png',
    'hands-open-d.png',
    'hands-open-e.png',
    'hands-open-f.png',
    'hands-open-g.png',
    'hands-open-h.png',
    'hands-open-i.png',
    'hands-open-j.png',
    'hands-shake-a.png',
    'hands-shake-b.png',
    'hands-shake-c.png',
    'hands-thumbs-up-a.png',
    'hands-thumbs-up-b.png',
    'hands-thumbs-up-c.png',
    'hands-thumbs-up-d.png',
    'hands-thumbs-up-e.png',
    'hands-thumbs-up-f.png',
    'hands-thumbs-up-g.png',
    'hands-thumbs-up-h.png',
    'headset-a.png',
    'headset-b.png',
    'headset-c.png',
    'headset-d.png',
    'headset-e.png',
    'jar-a.png',
    'jar-b.png',
    'keys-car-a.png',
    'keys-car-b.png',
    'keys-car-c.png',
    'keys-set-a.png',
    'keys-set-b.png',
    'keys-set-c.png',
    'keys-set-d.png',
    'keys-single-a.png',
    'keys-single-b.png',
    'keys-single-c.png',
    'laptop-a.png',
    'laptop-b.png',
    'laptop-c.png',
    'laptop-d.png',
    'laptop-e.png',
    'laptop-f.png',
    'lightbulb-a.png',
    'lightbulb-b.png',
    'location-pin-a.png',
    'location-pin-b.png',
    'location-pin-c.png',
    'location-pin-d.png',
    'lock-locked-a.png',
    'lock-locked-b.png',
    'lock-locked-c.png',
    'lock-locked-d.png',
    'lock-unlocked-a.png',
    'lock-unlocked-b.png',
    'lock-unlocked-c.png',
    'lock-unlocked-d.png',
    'maginfiying-glass-a.png',
    'maginfiying-glass-b.png',
    'maginfiying-glass-c.png',
    'maginfiying-glass-d.png',
    'megaphone-a.png',
    'megaphone-b.png',
    'megaphone-c.png',
    'megaphone-d.png',
    'megaphone-e.png',
    'not-allowed-a.png',
    'not-allowed-b.png',
    'not-allowed-c.png',
    'package-bag-a.png',
    'package-bag-b.png',
    'package-bag-c.png',
    'package-bag-d.png',
    'package-bag-e.png',
    'package-box-a.png',
    'package-box-b.png',
    'package-box-c.png',
    'package-box-d.png',
    'package-box-e.png',
    'package-box-f.png',
    'paper-stack-a.png',
    'paper-stack-b.png',
    'paper-stack-c.png',
    'paper-with-clip-a.png',
    'paper-with-clip-b.png',
    'paper-with-clip-c.png',
    'pen-a.png',
    'pen-b.png',
    'pen-c.png',
    'pen-d.png',
    'pen-e.png',
    'pen-f.png',
    'pencils-a.png',
    'pencils-b.png',
    'pencils-c.png',
    'phone-handset-a.png',
    'phone-handset-b.png',
    'phone-handset-c.png',
    'phone-handset-d.png',
    'phone-handset-e.png',
    'phone-handset-f.png',
    'phone-old-a.png',
    'phone-old-b.png',
    'phone-old-c.png',
    'phone-old-d.png',
    'phone-old-e.png',
    'phone-smart-a.png',
    'phone-smart-b.png',
    'phone-smart-c.png',
    'phone-smart-d.png',
    'phone-smart-e.png',
    'phone-smart-f.png',
    'phone-voip-a.png',
    'phone-voip-b.png',
    'phone-voip-c.png',
    'phone-voip-d.png',
    'phone-voip-e.png',
    'pill-bottle-a.png',
    'pill-bottle-b.png',
    'plane-a.png',
    'plane-b.png',
    'plane-c.png',
    'plane-d.png',
    'plant-a.png',
    'plant-b.png',
    'plant-c.png',
    'plant-d.png',
    'puzzle-jigsaw-a.png',
    'puzzle-jigsaw-b.png',
    'puzzle-jigsaw-c.png',
    'puzzle-jigsaw-d.png',
    'puzzle-jigsaw-e.png',
    'puzzle-jigsaw-f.png',
    'puzzle-jigsaw-g.png',
    'puzzle-jigsaw-h.png',
    'puzzle-jigsaw-i.png',
    'puzzle-jigsaw-j.png',
    'puzzle-jigsaw-k.png',
    'puzzle-jigsaw-l.png',
    'puzzle-jigsaw-m.png',
    'puzzle-jigsaw-n.png',
    'puzzle-jigsaw-o.png',
    'puzzle-jigsaw-p.png',
    'puzzle-rubiks-a.png',
    'puzzle-rubiks-b.png',
    'puzzle-rubiks-c.png',
    'puzzle-rubiks-d.png',
    'robot-arm-a.png',
    'robot-arm-b.png',
    'robot-arm-c.png',
    'rotonda-a.png',
    'rotonda-b.png',
    'rotonda-c.png',
    'shopping-bags-set-a.png',
    'shopping-bags-set-b.png',
    'shopping-bags-single-a.png',
    'shopping-bags-single-b.png',
    'shopping-bags-single-c.png',
    'shopping-bags-single-d.png',
    'shopping-cart-a.png',
    'shopping-cart-b.png',
    'shopping-cart-c.png',
    'shopping-cart-d.png',
    'sign-construction-a.png',
    'sign-construction-b.png',
    'sign-give-way-a.png',
    'sign-give-way-b.png',
    'sign-no-parking-a.png',
    'sign-no-parking-b.png',
    'sign-no-parking-c.png',
    'sign-no-parking-d.png',
    'sign-no-stopping.png',
    'sign-stop-a.png',
    'sign-stop-b.png',
    'sign-street-a.png',
    'sign-street-b.png',
    'sign-street-c.png',
    'sign-street-d.png',
    'stethoscope-a.png',
    'stethoscope-b.png',
    'suitcase-a.png',
    'suitcase-b.png',
    'suitcase-c.png',
    'suitcase-d.png',
    'suitcase-e.png',
    'tag-a.png',
    'tag-b.png',
    'tag-c.png',
    'tool-adjustable-wrench-a.png',
    'tool-adjustable-wrench-b.png',
    'tool-box-end-a.png',
    'tool-box-end-b.png',
    'tool-hammer-a.png',
    'tool-hammer-b.png',
    'tool-wrench-a.png',
    'tool-wrench-b.png',
    'tool-wrench-c.png',
    'traffic-cone-a.png',
    'traffic-cone-b.png',
    'traffic-cone-c.png',
    'traffic-cone-d.png',
    'traffic-cone-e.png',
    'vehicle-car-a.png',
    'vehicle-car-b.png',
    'vehicle-car-c.png',
    'vehicle-truck-a.png',
    'vehicle-truck-b.png',
    'vehicle-truck-c.png',
    'vehicle-truck-d.png',
    'vehicle-truck-e.png',
    'vehicle-truck-f.png',
    'text-bubble-c.png',
    'text-bubble-d.png',
    'text-bubble-a.png',
    'text-bubble-b.png',
    'text-bubble-e.png',
    'text-bubble-f.png',
    'text-bubble-g.png',
    'vehicle-tractor-d.png',
    'text-bubble-h.png',
    'vehicle-tractor-b.png',
    'vehicle-tractor-a.png',
    'gym-weights-a.png',
    'vehicle-tractor-c.png',
    'building-farmhouse-a.png',
    'building-farmhouse-e.png',
    'building-farmhouse-c.png',
    'building-farmhouse-b.png',
    'building-farmhouse-d.png',
    'gym-dumbel-a.png',
    'gym-weights-b.png',
    'gym-dumbel-c.png',
    'gym-dumbel-b.png',
    'hard-hat-a.png',
    'gym-dumbel-d.png',
    'hard-hat-b.png',
    'hard-hat-c.png',
    'bell-b.png',
    'bell-a.png',
    'gym-weights-d.png',
    'hard-hat-d.png',
    'bell-c.png',
    'gym-weights-c.png',
    'sign-for-sale-a.png',
    'sign-taxi-back-a.png',
    'gym-watter-bottle-d.png',
    'sign-for-sale-b.png',
    'gym-watter-bottle-a.png',
    'gym-watter-bottle-c.png',
    'gym-watter-bottle-b.png',
    'sign-taxi-back-b.png',
    'sign-taxi-back-c.png',
    'sign-taxi-back-e.png',
    'sign-taxi-front-b.png',
    'sign-for-sale-c.png',
    'sign-taxi-back-d.png',
    'sign-taxi-front-a.png',
    'sign-for-sale-d.png',
    'sign-taxi-front-e.png',
    'sign-taxi-front-c.png',
    'sign-taxi-front-d.png',
    'vehicle-taxi-d.png',
    'vehicle-taxi-f.png',
    'vehicle-taxi-a.png',
    'vehicle-taxi-e.png',
    'vehicle-taxi-b.png',
    'vehicle-taxi-c.png'
];

export const IMAGES = organizeImagesWithVariations(imageFilenames);

export default IMAGES;